import { Button, Col, Row, notification } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';
import TabContentWrapper from './TabContentWrapper';
import DownloadCardWrapper from './DownloadCardWrapper';
import DownloadCenterService from '../../services/DownloadCenterService';

const reports = [
  {
    name: 'Share Transfer Report',
    description: 'Information on share transfers between traders',
    apiUrl: '/secured/share_transfer_report',
  },
  {
    name: 'Individual Traders',
    description: 'List of trading individuals with their portfolio',
    apiUrl: '/secured/individual_trader_report',
  },
  {
    name: 'Corporate Traders',
    description: 'List of corporate traders with their portfolio',
    apiUrl: '/secured/corporate_trader_report',
  },
  {
    name: 'Individual Shareholding',
    description: 'Shareholding details of the individual traders',
    apiUrl: '/secured/individual_share_holding_report',
  },
  {
    name: 'Corporate Shareholding',
    description: 'Shareholding details of the companies',
    apiUrl: '/secured/corporate_share_holding_report',
  },
];

const InstantReport = () => {
  const [noti, contextHolder] = notification.useNotification();

  const handleDownload = async (apiUrlString, fileName) => {
    const result = await DownloadCenterService.download(
      apiUrlString,
      fileName,
      fileName === 'Share Transfer Report' ? { startDate: null, endDate: null } : {}, // will be moved to date filtered report section in the future
    );

    if (!result.success) {
      noti.error({
        message: result.code || 'Download failed',
        description: result.message || 'Unknown error occurred',
        placement: 'topRight',
      });
    }
  };

  return (
    <TabContentWrapper title="Instant Reports" text="Get the whole report without filters">
      {contextHolder}
      <Row gutter={[16, 16]}>
        {reports.map((report, index) => (
          <Col xs={24} md={12} key={index}>
            <DownloadCardWrapper
              tagMessage={'No filter needed'}
              title={report.name}
              description={report.description}
              color={'success'}
            >
              <Button
                icon={<CloudDownloadOutlined />}
                type="primary"
                block
                onClick={() => handleDownload(report.apiUrl, report.name)}
              >
                Download
              </Button>
            </DownloadCardWrapper>
          </Col>
        ))}
      </Row>
    </TabContentWrapper>
  );
};

export default InstantReport;
